import { Route } from '@angular/router';
import { AuthComponent } from '../pages/auth/auth.component';
import { authAdminGuard, authSuperAdminGuard } from '../shared/auth.guard';
import { EmailVerificationNoticeComponent } from '../pages/auth/email-verification-notice/email-verification-notice.component';
import { EmailVerifiedComponent } from '../pages/auth/email-verified/email-verified.component';
import { ResetPasswordComponent } from '../pages/auth/reset-password/reset-password.component';
import { ComingSoonComponent } from '../shared/widgets/coming-soon/coming-soon.component';
import { AdminLayoutComponent } from '../pages/admin/admin.component';
import { SuperAdminLayoutComponent } from '../pages/super-admin/super-admin.component';

export const APP_ROUTES: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/login',
  },
  {
    path: 'auth',
    component: AuthComponent,
    // redirectTo: '/login',
    // pathMatch: 'full',
    loadChildren: () =>
      import('../pages/auth/auth.route').then((route) => route.AUTH_ROUTES),
  },
  {
    path: 'email-notice',
    component: EmailVerificationNoticeComponent,
  },
  {
    path: 'coming-soon',
    component: ComingSoonComponent,
    canActivate: [authAdminGuard],
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('../pages/admin/admin.route').then((route) => route.ADMIN_ROUTES),
    canActivate: [authAdminGuard],
  },
  {
    path: 'super-admin',
    component: SuperAdminLayoutComponent,
    loadChildren: () =>
      import('../pages/super-admin/super-admin.route').then(
        (route) => route.SUPER_ADMIN_ROUTES
      ),
    canActivate: [authSuperAdminGuard],
  },
  { path: '**', redirectTo: '/auth/login' },
];

export class AppRoutingModule {}
